// Map a formal-wear color name to a CSS color for swatch dots.
const COLOR_MAP = {
  "navy blue": "#1b2a4a", "midnight blue": "#141d33", "royal blue": "#1f4ea8",
  "sky blue": "#7fb3e0", "light blue": "#bcd6ef", "black": "#1a1a1a",
  "onyx black": "#15110f", "charcoal": "#36393d", "grey": "#8a8d91",
  "light grey": "#c3c5c8", "white": "#f6f4ef", "beige": "#d9c7a7",
  "camel": "#b88b56", "brown": "#5a3a26", "oxblood": "#5a1f22",
  "burgundy": "#6e1f33", "red": "#a8242b", "emerald": "#1f7a52",
  "pink": "#e3b9c6", "lavender": "#b9a7d6", "champagne": "#e6d4ac",
  "gold": "#c9a86a", "silver": "#c8ccce", "nude": "#dcc1a8",
};

export function colorToCss(name) {
  if (!name) return "var(--border-strong)";
  return COLOR_MAP[name.trim().toLowerCase()] || "var(--accent)";
}

// Hex for a color name (null if unknown).
export function colorHex(name) {
  if (!name) return null;
  return COLOR_MAP[name.trim().toLowerCase()] || null;
}

// True for pale colors that need dark text/icons on top.
export function isLightColor(name) {
  const hex = colorHex(name);
  if (!hex) return false;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.62;
}

// A slightly darker shade of the color, for a tasteful gradient.
export function shadeColor(name, amount = -22) {
  const hex = colorHex(name);
  if (!hex) return "var(--accent-dark)";
  const clamp = (v) => Math.max(0, Math.min(255, v));
  const r = clamp(parseInt(hex.slice(1, 3), 16) + amount);
  const g = clamp(parseInt(hex.slice(3, 5), 16) + amount);
  const b = clamp(parseInt(hex.slice(5, 7), 16) + amount);
  return `#${[r, g, b].map((v) => v.toString(16).padStart(2, "0")).join("")}`;
}
